import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vaccine-measures',
  templateUrl: './vaccine-measures.component.html',
  styleUrls: ['./vaccine-measures.component.scss']
})
export class VaccineMeasuresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
